//----- Component --------------------------------------------------------/
// Developer : Daiana Curcio
// Creation Date : 31/03/2025
// Version : 1
// Description : pantalla para ver el resumen de vehiculos con kg vendido,
// km recorridos y litros de combustible
//------Changes --------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/

import React, { useState, useEffect } from "react";
import { UrlApi } from "../../../services/apirest";
import {
  Typography,
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  InputAdornment,
} from "@mui/material";
import Navbar from "../../Navbar";
import SearchIcon from "@mui/icons-material/Search";
import { logEventos } from "../../../services/services";
import { useMediaQuery } from "@mui/material";

function ResumenVehiculos() {
  const [resumenVehiculos, setResumenVehiculos] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const isMobile = useMediaQuery("(max-width:600px)");

  const obtenerResumenVehiculos = () => {
    if (!selectedDate) return; // No hacer la petición si no hay fecha seleccionada SINO TIRA ERROR
    fetch(UrlApi + "/checklist_chofer_flota/resumenVehiculos/" + formattedDate)
      .then((data) => data.json())
      .then((data) => setResumenVehiculos(data));
  };

  // console.log("resumen vehiculos", resumenVehiculos);

  useEffect(() => {
    obtenerResumenVehiculos();
  }, [selectedDate]); // Actualizar los datos cuando se cambie la fecha

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };
  const formattedDate = `${selectedDate}`;
  //console.log("Mes seleccionado:", formattedDate);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  };

  // Filtrar los datos basados en la búsqueda
  const vehiculosFiltrados = resumenVehiculos.filter(
    (vehiculo) =>
      (vehiculo.patente?.toLowerCase() || "").includes(searchQuery) ||
      (vehiculo.marca?.toLowerCase() || "").includes(searchQuery) ||
      (vehiculo.modelo?.toLowerCase() || "").includes(searchQuery) ||
      (vehiculo.sucursal?.toLowerCase() || "").includes(searchQuery)
  );
  // *********************************************************** Tabla ********************************************************************** //
  useEffect(() => {
    logEventos(
      "acceso al menú Resumen Vehículos",
      "Evaluacion Comerciales",
      "Resumen Vehículos",
      localStorage.getItem("user")
    );
  }, []);
  return (
    <div>
      <Navbar />
      <Box
        bgcolor="#2B76A6"
        padding={2}
        borderRadius={0}
        color="white"
        textAlign="center"
      >
        <Grid container>
          <Grid
            item
            xs={12}
            md={4}
            textAlign={isMobile ? "center" : "left"}
            marginBottom={1}
          >
            <Typography variant="h4" component="div">
              Resumen Vehículos
            </Typography>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          md={12}
          container
          spacing={2}
          justifyContent={isMobile ? "center" : "center"}
        >
          <Grid item xs={12} sm={6} md="auto">
            <TextField
              focused
              size="small"
              type="month"
              value={selectedDate}
              onChange={handleDateChange}
              InputLabelProps={{
                sx: { color: "white" }, // Color de la etiqueta
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "white" }, // Borde blanco
                  "&:hover fieldset": { borderColor: "black" }, // Borde blanco al pasar el mouse
                  "&.Mui-focused fieldset": { borderColor: "white" }, // Borde blanco al enfocar
                },
                "& .MuiInputLabel-root": {
                  color: "white", // Color del label
                },
                "& .MuiInputBase-input": {
                  color: "white", // Texto en blanco
                  "&::-webkit-calendar-picker-indicator": {
                    filter: "invert(1)", // Cambia el color del icono a blanco
                  },
                },
              }}
            />
          </Grid>
          {/* TextField para búsqueda */}
          <Grid item xs={12} sm={6} md="auto">
            <TextField
              variant="outlined"
              size="small"
              placeholder="Buscar..."
              autoComplete="off"
              value={searchQuery}
              onChange={handleSearchChange}
              sx={{
                width: "250px",
                backgroundColor: "white",
                "& .MuiInputLabel-root": {
                  color: "black",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "white",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "black",
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ color: "gray" }} />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
      </Box>
      <TableContainer
        component={Paper}
        sx={{ borderRadius: 2, boxShadow: 10, mt: 3}}
      >
        <Box sx={{ maxHeight: "80vh", overflow: "auto" }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow
                sx={{
                  position: "sticky",
                  top: 0,
                  zIndex: 2,
                }}
              >
                <TableCell
                  sx={{
                    color: "white",
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: 14, sm: 12, md: 14 },
                    padding: "4px 6px",
                    backgroundColor: "#2B76A6",
                    minWidth: 80,
                  }}
                >
                  Patente
                </TableCell>
                <TableCell
                  sx={{
                    color: "white",
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: 14, sm: 12, md: 14 },
                    padding: "4px 6px",
                    backgroundColor: "#2B76A6",
                    minWidth: 80,
                  }}
                >
                  Marca
                </TableCell>
                <TableCell
                  sx={{
                    color: "white",
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: 14, sm: 12, md: 14 },
                    padding: "4px 6px",
                    backgroundColor: "#2B76A6",
                    minWidth: 80,
                  }}
                >
                  Modelo
                </TableCell>
                <TableCell
                  sx={{
                    color: "white",
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: 14, sm: 12, md: 14 },
                    padding: "4px 6px",
                    backgroundColor: "#2B76A6",
                    minWidth: 80,
                  }}
                >
                  Sucursal
                </TableCell>
                <TableCell
                  sx={{
                    color: "white",
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: 14, sm: 12, md: 14 },
                    padding: "4px 6px",
                    backgroundColor: "#2B76A6",
                    minWidth: 80,
                  }}
                >
                  Días Inactivos
                </TableCell>
                <TableCell
                  sx={{
                    color: "white",
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: 14, sm: 12, md: 14 },
                    padding: "4px 6px",
                    backgroundColor: "#2B76A6",
                    minWidth: 80,
                  }}
                >
                  Kg Vendidos
                </TableCell>
                <TableCell
                  sx={{
                    color: "white",
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: 14, sm: 12, md: 14 },
                    padding: "4px 6px",
                    backgroundColor: "#2B76A6",
                    minWidth: 80,
                  }}
                >
                  Km Recorridos
                </TableCell>
                <TableCell
                  sx={{
                    color: "white",
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: 14, sm: 12, md: 14 },
                    padding: "4px 6px",
                    backgroundColor: "#2B76A6",
                    minWidth: 80,
                  }}
                >
                  Litros Comb.
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {vehiculosFiltrados.length > 0 ? (
                vehiculosFiltrados.map((vehiculo, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      border: "1px solid black",
                      backgroundColor: index % 2 === 0 ? "#FFFFFF" : "#DADADA", // Alterna colores por línea
                      "& td": { padding: "3px 8px", fontSize: 14 },
                    }}
                  >
                    <TableCell
                      sx={{
                        textAlign: "left",
                        borderRight: "1px solid black",
                      }}
                    >
                      {vehiculo.patente}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "left",
                        borderRight: "1px solid black",
                      }}
                    >
                      {vehiculo.marca}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "left",
                        borderRight: "1px solid black",
                      }}
                    >
                      {vehiculo.modelo}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "left",
                        borderRight: "1px solid black",
                      }}
                    >
                      {vehiculo.sucursal}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "right",
                        borderRight: "1px solid black",
                      }}
                    >
                      {vehiculo.total_dias_inactivos}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "right",
                        borderRight: "1px solid black",
                      }}
                    >
                      {vehiculo.total_kg_vendidos}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "right",
                        borderRight: "1px solid black",
                      }}
                    >
                      {vehiculo.total_km_recorridos}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "right",
                        borderRight: "1px solid black",
                      }}
                    >
                      {vehiculo.total_litros_combustible}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={8}
                    align="center"
                    sx={{ fontWeight: "bold",fontSize: 14 }}
                  >
                    No hay datos para la fecha seleccionada.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Box>
      </TableContainer>
      <br></br>
      <br></br>
      <br></br>
    </div>
  );
}

export default ResumenVehiculos;
